import { render, staticRenderFns } from "./CustomNotification.vue?vue&type=template&id=761dc9aa"
import script from "./CustomNotification.vue?vue&type=script&lang=js"
export * from "./CustomNotification.vue?vue&type=script&lang=js"
import style0 from "./CustomNotification.vue?vue&type=style&index=0&id=761dc9aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports